import { Result } from '@standardnotes/domain-core';
export class SetHost {
    constructor(http, legacyApi) {
        this.http = http;
        this.legacyApi = legacyApi;
    }
    async execute(host) {
        this.http.setHost(host);
        await this.legacyApi.setHost(host);
        return Result.ok();
    }
}
